import PropTypes from 'prop-types';
import React from 'react';

const ChangeUnits = ({ href }) => (
  <a href={href} className="sl-change-units">
    Change units
  </a>
);

ChangeUnits.propTypes = {
  href: PropTypes.string.isRequired,
};

export default ChangeUnits;
